import React, { useState } from 'react';
import { OtherTranslations } from '../../hooks/queries/OtherTranslations';
import { FaCheck, FaTimes, FaSpinner } from 'react-icons/fa';

export const HelpfulArticleForm = props => {
  const [showYesForm, toggleShowYesForm] = useState(false);
  const [showNoForm, toggleShowNoForm] = useState(false);
  const [showThankYouMessage, toggleShowThankYouMessage] = useState(false);
  const [showErrorMessage, toggleShowErrorMessage] = useState(false);
  const [showSpinnerIcon, toggleShowSpinnerIcon] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorsUnhelpfulPicked, setErrorsUnhelpfulPicked] = useState(false);
  const [errorsNoComments, setErrorsNoComments] = useState(false);

  const data = OtherTranslations();
  const t = data.mb.otherTranslation.localizations.find(item => item.locale === props.locale) || data.mb.otherTranslation;

  const yesItWas = () => {
    // toggleShowYesForm(!showYesForm);
    toggleShowSpinnerIcon(true);
    submitYesItWas();
    if(showNoForm) {
      toggleShowNoForm(!showNoForm);
    }
  }

  const noItWasnt = () => {
    toggleShowNoForm(!showNoForm);
    if(showYesForm) {
      toggleShowYesForm(!showYesForm);
    }
  }

  const showInitialForm = () => {
    toggleShowThankYouMessage(false);
    toggleShowErrorMessage(false);
  }

  const submitYesItWas = () => {
    const data = {
      // "yes_comment": values.yes_comments,
      "blogpost": {
        "id": parseInt(props.blogpost_id)
      },
      "Helpful_Yes_No": "Yes",
    }
    sendForm(data);
  }

  const submitNoItWasnt = () => {
    setErrorsUnhelpfulPicked(false);
    setErrorsNoComments(false);
    let inputErrors = false;
    const data = {
      "no_comment": '',
      "no_reason": '',
      "blogpost": {
        "id": parseInt(props.blogpost_id)
      },
      "Helpful_Yes_No": "No",
    }

    if(document.querySelectorAll('input[type="radio"]:checked').length > 0) {
      setErrorsUnhelpfulPicked(false);
      data.no_reason = document.querySelectorAll('input[type="radio"]:checked')[0].value;
    }
    else {
      setErrorsUnhelpfulPicked(true);
      inputErrors = true;
    }

    if(document.getElementsByName('no_comments')[0].value) {
      setErrorsNoComments(false);
      data.no_comment = document.getElementsByName('no_comments')[0].value;
    } 
    else {
      setErrorsNoComments(true);
      inputErrors = true;
    }
    
    if(inputErrors) {
      return;
    }

    sendForm(data);
  }

  const sendForm = (data = {}) => {
    const url = '/support-center/api/helpful-articles';

    fetch(url, {
      method: 'post',
      body: JSON.stringify(data),
      headers: {
        'Content-Type': 'application/json'
      },
      mode: 'cors',
    }).then(response => {
      return response.json();
    }).then(data => {
      if (isSubmitting) {
        setIsSubmitting(false);
      }
      toggleShowSpinnerIcon(false);
      toggleShowThankYouMessage(true);
      toggleShowNoForm(false);
      toggleShowYesForm(false);
    }, (error) => {
      console.log(error);
      if (isSubmitting) {
        setIsSubmitting(false);
      }
      showErrorMessage(false);
      toggleShowSpinnerIcon(false);
    });
  } 

  const cleanForm = () => {
    setErrorsNoComments(false);
    setErrorsUnhelpfulPicked(false);
  }

  return (
    <div className="block-sm helpful-article-form">
      <div className="container">
        <hr className="margin-bottom" />

        <div className={`first-section ${(showThankYouMessage || showErrorMessage) ? 'hidden' : null}`}>
          <h5 className="text-center">{t.helpful_article_title}</h5>
          <div className="row">
            <div className="col-md-12 text-center">
              <button type="button" className="btn btn-default" onClick={yesItWas}>
                <FaSpinner className={`icon-spin icon ${showSpinnerIcon ? '' : 'hidden'}`} />
                <FaCheck className={`icon ${showSpinnerIcon ? 'hidden' : ''}`} />
                {t.helpful_article_yes_it_was}
              </button>
              <button type="button" className="btn btn-default" onClick={noItWasnt}>
                <FaTimes className="icon" />
                {t.helpful_article_no_it_wasnt}
              </button>
            </div>
          </div>
        </div>

        {/* No It Wasn't form */}
        <div className={`no-it-wasnt ${showNoForm ? null : 'hidden'}`}>
          <form>
            <div className="row row-centered">
              <div className="col-md-6 col-centered">
                <p className="margin-top"><strong>{t.helpful_article_no_form_title}</strong></p>
                <div className={`radio-group ${errorsUnhelpfulPicked ? 'field-errors' : ''}`} role="group" onChange={cleanForm} aria-labelledby="my-radio-group">
                  <label>
                    <input type="radio" name="unhelpful_picked" value={t.helpful_article_answers_option_1} />
                    {t.helpful_article_answers_option_1}
                  </label>
                  <label>
                    <input type="radio" name="unhelpful_picked" value={t.helpful_article_answers_option_2} />
                    {t.helpful_article_answers_option_2}
                  </label>
                  <label>
                    <input type="radio" name="unhelpful_picked" value={t.helpful_article_answers_option_3} />
                    {t.helpful_article_answers_option_3}
                  </label>
                  <label>
                    <input type="radio" name="unhelpful_picked" value={t.helpful_article_answers_option_4} />
                    {t.helpful_article_answers_option_4}
                  </label>
                </div>
                {
                  errorsUnhelpfulPicked && <div name="unhelpful_picked_error" className="field-error-message">Please select one of the reasons above</div>
                }

                <textarea rows="6" className={`form-control margin-top-sm ${errorsNoComments ? 'field-errors' : ''}`} onChange={cleanForm} name="no_comments" placeholder={t.helpful_article_no_placeholder} style={{ width: '100%' }}></textarea>
                {
                  errorsNoComments && <div name="no_comments_errors" className="field-error-message">This value is required</div>
                }
              </div>
            </div>
            <div className="row row-centered">
              <div className="col-md-6 col-centered">
                <button type="button" disabled={isSubmitting} className="btn btn-blue pull-right" onClick={submitNoItWasnt}>
                  <FaSpinner className={`icon-spin icon ${isSubmitting ? '' : 'hidden'}`} />
                  {t.helpful_article_send_feedback}
                </button>
              </div>
            </div>
          </form>
        </div>
        
        {/* Thank you message */}
        <div className={`row row-centered ${showThankYouMessage ? null : 'hidden'}`}>
          <div className="col-md-6 col-centered">
            <h4 className="text-center">{t.helpful_article_thank_you_title}</h4>
            <p className="text-center">{t.helpful_article_thank_you_message} <a href="mailto: support@freeconferencecall.com" title="support@freeconferencecall.com">support@freeconferencecall.com</a>.</p>
          </div>
        </div>

        {/* Error message */}
        <div className={`row row-centered ${showErrorMessage ? null : 'hidden'}`}>
          <div className="col-md-6 col-centered">
            <div className="alert alert-danger text-center">
              <h4 className="text-center">{t.helpful_article_error}</h4>
              <p className="text-center">{t.helpful_article_try_again}</p>
              <button type="button" className="btn btn-red" onClick={showInitialForm} title={t.helpful_article_try_again}>
                {t.helpful_article_try_again}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
